import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getProductList } from "../../services/product.service";
import { OPTIONS_TOAST } from "../../shared/consts";

const initialState = {
  isLoading: false,
  list: [],
  currentPageList: 1,
  totalPageList: 1,
  sizePageList: 1,
  errorMsg: null,
};

/** SLICES */
export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductList.pending, (state, action) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(getProductList.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload.data;
        return {
          ...state,
          isLoading: false,
          list: data,
          errorMsg: null,
        };
      }
      return state;
    });
    builder.addCase(getProductList.rejected, (state, action) => {
      toast.dismiss();
      toast.error(`${action.payload}`, OPTIONS_TOAST);
      return {
        ...state,
        isLoading: false,
        errorMsg: action.payload,
      };
    });
  },
});

// export const { } = roleSlice.actions;
export default productSlice.reducer;
